import { Alert } from 'antd'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { showToastAction } from '../../redux/toastSlice'

const ToastComponent = () => {
    const dispatch = useDispatch()
    const toastState = useSelector(state => state.toast)
    const { message = "", showToast = false, severity } = toastState || {}

    useEffect(() => {
        let timer
        if (showToast) {
            timer = setTimeout(() => {
                dispatch(showToastAction({ message: "", showToast: false }))
            }, 6000)
        }
        return () => {
            clearTimeout(timer)
        }
    }, [showToast])

    return (
        <div className='toast_container'>
            {
                showToast && message &&
                <Alert
                    message={message}
                    type={severity ? severity : "error"}
                    showIcon closable
                    afterClose={() => dispatch(showToastAction({ message: "", showToast: false }))}
                />
            }
        </div>
    )
}

export default ToastComponent